import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { ShopContext } from '../Context/ShopContext'
import Breadcrum from '../Components/Breadcrum/Breadcrum';
import ProductDisplay from '../Components/ProductDisplay/ProductDisplay';
import ProductDescription from '../Components/ProductDescription/ProductDescription';
import RelatedProducts from '../Components/RelatedProducts/RelatedProducts';
import './Styles/Product.css'

const Product = () => {
  const {all_products} = useContext(ShopContext);
  const {productid} = useParams();
  const product = all_products.find((product) => product.id === Number(productid));

  if (!product) {
    return <div>Loading...</div>; // or show a spinner
  }
  
  return (
    <div>
      <Breadcrum product={product} />
      <ProductDisplay product={product} />
      <ProductDescription product={product} />
      <RelatedProducts product={product} />
    </div>
  )
}

export default Product